import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { ResSearch } from 'src/app/model/reservation.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class ReservationService {

  constructor(
    private requestService: RequestService
  ) { }

  GetDefaultData(CompanyID:string,UserID:string){
    var param = {
      "CompanyID": CompanyID,
      "UserID": UserID
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Reservation/GetDefaultData',param);
  }

  GetReserved(model:any){
    return this.requestService.Post<any>(environment.baseUrl + '/Reservation/GetReserved',model);
  }

  CreateReservation(model:any){
    //新增預約
    return this.requestService.Post<any>(environment.baseUrl + '/Reservation/CreateReserved',model);
  }

  GetConsentForm(CompanyID:string){
    var model = new ResSearch();
    model.CompanyID = CompanyID;
    model.Type = "美容";
    var param = {
      "model": model,
      "type": "0"
    };
    return this.requestService.Post<any>(environment.baseUrl + '/Reservation/GetConsentFormForLine',param);
  }
  SaveSign(model:any){
    return this.requestService.Post<any>(environment.baseUrl + '/Reservation/SaveSign',model);
  }
}
